<section class="main-content wrapper">

    <div class="col-100">
        <div class="valet-selection">

            <div class="heading">
                <h2>
                    <b>
                        VALET
                        <span *ngIf="selectedExpertId">| {{selectedValet?.user?.surname?.toUpperCase()}} {{selectedValet?.user?.name?.toUpperCase()}}</span>
                    </b>
                </h2>

               <div class="button-wrapper">
                    <ng-template [ngIf]="selected">
                        <button class="btn hvr-grow has-margin-right" routerLink="/activities/other/valet/storico">
                            <i class="mr-10 far fa-folder"></i>Storico
                        </button>
                    </ng-template>
        
                    <ng-template [ngIf]="!selected">
                        <button class="btn hvr-grow has-margin-right" [routerLink]="['../']" [queryParams]="{navigation: 'back'}">
                            <i class="mr-10 fas fa-arrow-left"></i>Ritorna
                        </button>
                    </ng-template>
        
                    <select [(ngModel)]="selectedExpertId" (ngModelChange)="handleValetChange($event)" id="selezionePartner" class="">
                        <option [ngValue]="null" disabled selected>Select Valet</option>
                        <option *ngFor="let expert of experts" [ngValue]="expert.id">{{expert.user.surname}} {{expert.user.name}}</option>
                    </select>
                    
                    <button class="btn hvr-grow has-margin-right" *ngIf="adminValetActivities.length && ((groups.includes('admin')) || (groups.includes('expert') && isTeamLeader))" (click)="changeActivityOrderAccordingTime()"> 
                        Reorder With Time
                    </button>
        
                    <button class="btn hvr-grow has-margin-right" *ngIf="(selectedExpertId && adminValetActivities.length > 0)" (click)="renderMap()" [disabled]="optimzeMap"> 
                        <i matTooltip="Google Map"
                            class="material-icons action-icon"
                            style="color: #ffffff;" 
                            >location_on
                        </i>
                    </button>
        
                    <button class="btn hvr-grow has-margin-right" *ngIf="(selectedExpertId && adminValetActivities.length > 0)" [disabled]="!optimzeMap" (click)="resetMap()"> 
                        <i matTooltip="Reset"
                        class="material-icons action-icon"
                        style="color: #ffffff;"
                        >refresh
                        </i>
                    </button>
               </div>
            </div>
        </div>
    </div>
    <br class="clear">

    <div class="filter-accordion">
        <div class="filter-accordion-header" (click)="toggleAccordion('filter')">
          <h3>FILTERS</h3>
          <i class="fas" [ngClass]="{ 'fa-chevron-down': !isFilterAccordionOpen, 'fa-chevron-up': isFilterAccordionOpen }"></i>
        </div>
        <form [formGroup]="activityFilterForm" (ngSubmit)="filter()" *ngIf="activityFilterForm">
          <div class="filter-accordion-content" [ngClass]="{ 'open': isFilterAccordionOpen }">
            <div class="filter-container">
              <div class="filter-item">
                <label for="fromDate">Date From:</label>
                <input type="date" id="fromDate"formControlName="AdminValetActivity.deliveryDate_from" placeholder="YYYY-MM-DD">
              </div>
              <div class="filter-item">
                <label for="toDate">Date To:</label>
                <input type="date" id="toDate"formControlName="AdminValetActivity.deliveryDate_to" placeholder="YYYY-MM-DD">
              </div>
              <div class="filter-item">
                <label for="search">Search:</label>
                <input type="text" id="search" formControlName="AdminValetActivity.customFilter" placeholder="Enter businessName, address, product">
              </div>
            </div>
            <div class="button-container">
              <button class="btn hvr-grow"  (click)="$event.preventDefault(); filter()">
                <i class="fas fa-search"></i> 
              </button>
              <button type="button" class="btn hvr-grow has-margin-right" (click)="$event.preventDefault(); resetFilter();">
                <i class="fas fa-undo"></i> 
              </button>
            </div>
          </div>
        </form>
    </div>

    <!-- Map Related Code -->
    <div class="filter-accordion">
        <div class="filter-accordion-header" (click)="toggleAccordion('optimizemap')">
            <h3>OPTIMIZE ROUTES MAP</h3>
            <i class="fas" [ngClass]="{ 'fa-chevron-down': !isOptimizeMapAccordionOpen, 'fa-chevron-up': isOptimizeMapAccordionOpen }"></i>
        </div>
        <div class="filter-accordion-content" [ngClass]="{ 'open': isOptimizeMapAccordionOpen }">
            <button class="btn" (click)="seeMapInNewWindow()" *ngIf="(selectedValet && adminValetActivities.length > 0)">See Map in New Window</button>
            <p><strong>Distance:</strong> {{ optimizedData.distance }}</p>
            <p><strong>Duration:</strong> {{ optimizedData.duration }}</p>
            <div class="card-container map" id="optimizedMap"><!-- Map will render dynamically  --></div>
        </div>
    </div>
    <!-- Map Related Code -->

    <div class="activities-pagination">
        <app-pagination [limit]="limit" [page]="page" [count]="count" [maxPage]="maxPage" (load)="navigate($event)"></app-pagination>
    </div>

    <div class="column-box">
        <!-- deliveries-listing -->
        <div cdkDropList 
            #deliveriesList="cdkDropList" 
            id="deliveriesList"
            class="column-inner deliveries-listing" 
            [cdkDropListData]="deliveries"
            [cdkDropListConnectedTo]="['activitiesList']" 
            (cdkDropListDropped)="drop($event)"
            *ngIf="groups.includes('admin')">
            <h3>Deliveries | Count: {{ deliveries.length }}</h3>
            <div class="card-container" *ngFor="let delivery of deliveries, index as i" 
                cdkDrag
                cdkDragLockAxis="x">
                <!-- Action Buttons -->
                <div class="action-btns drag-icon">
                    <i class="material-icons" cdkDragHandle>open_with</i>
                </div>

                <!-- Accordion Header -->
                <div class="accordion-header" (click)="toggleAccordion('delivery', i)">
                    <div class="photo-container">
                        <div class="date">
                            <div class="day">{{ delivery.deliveryDate | date: 'dd' }}</div>
                            <div class="month">{{ delivery.deliveryDate | date: 'MMM' | uppercase }}</div>
                        </div>
                    </div>
                    <div class="service-image-container">
                        <div class="date">
                            <p>
                                <img class="service-img" [src]="showServiceDetails(delivery)?.service?.image" width="50" height="50" *ngIf="showServiceDetails(delivery)?.service?.image">
                            </p>
                        </div>
                    </div>
                    <div class="info-container">
                        <div class="event-name">DELIVERY ID: {{ delivery.id }}</div>
                        <span>
                            <b>ORA RITIRO: </b>{{ delivery?.pickUpTime || "---"}}
                            <br class="clear">
                        </span>
                        <span>
                            <b>ORARIO: </b>{{ formatTimeShow(delivery?.fromTime, delivery?.toTime) }}
                            <br class="clear">
                        </span>
                        <span>
                            <b>PARTNER: </b>{{ delivery?.partner?.businessName || "---"}}
                            <br class="clear">
                        </span>
                        <span>
                            <b>INDIRIZZO: </b>{{ (delivery?.address) }}
                            <br class="clear">
                        </span>
                        <span *ngIf="delivery?.serviceType?.toLowerCase() === 'sales' ">
                            <b>PRODUCT: </b><span *ngFor="let dProduct of delivery.deliveryProducts">{{dProduct.product?.name}} - {{ dProduct?.productVariant?.variantName }}</span>
                            <br class="clear">
                        </span>
                        <span>
                            <b>STATO: </b>{{deliveryStatusAux.ln('it', delivery?.status)}}
                            <br class="clear">
                        </span>
                    </div>
                    <div class="toggle-icon">
                        <i class="material-icons" [ngClass]="{'rotate-icon': activeAccordionDeliveryIndex === i}">expand_more</i>
                    </div>
                </div>

                <!-- Accordion Body -->
                <div class="accordion-body" *ngIf="activeAccordionDeliveryIndex === i">
                    <div class="additional-info">
                        <p>
                            <img class="service-img" [src]="showServiceDetails(delivery)?.service?.image" width="50" height="50" *ngIf="showServiceDetails(delivery)?.service?.image">
                        </p>
                        <p><strong>ORARIO:</strong> {{ formatTimeShow(showingDelivery.fromTime, showingDelivery.toTime) }}</p>
                        <p><strong>PARTNER:</strong> {{ showingDelivery.partner?.businessName }}</p>
                        <p><strong>INDIRIZZO:</strong> {{((showingDelivery.address ? showingDelivery.address : "") + (showingDelivery.city ? ", " + showingDelivery.city : "")) || "---"}}</p>
                        <p><strong>INDIRIZZO DI RITIRO:</strong> {{showingDelivery?.pickUpAddress || "---"}}</p>
                        <p><strong>ORA RITIRO:</strong> {{ showingDelivery?.pickUpTime || "---"}}</p>
                        <p>
                            <strong>TIPO SERVIZIO:</strong> 
                            {{ showingDelivery?.serviceType &&
                                (showingDelivery?.serviceType?.toLowerCase() === "fixedprice" ? "Servizi a Prezzo Fisso" :
                                (showingDelivery?.serviceType?.toLowerCase() === "hourlyrate" ? "Servizi a Ora" :
                                (showingDelivery?.serviceType?.toLowerCase() === "sales" ? "Servizi Vendita" : ""))) 
                            }}           
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <!-- deliveries-listing -->

        <!-- activity-listing -->
        <div cdkDropList 
            #activitiesList="cdkDropList" 
            id="activitiesList"
            class="column-inner activity-listing" 
            [cdkDropListData]="adminValetActivities"
            (cdkDropListDropped)="drop($event)"
            *ngIf="((groups.includes('admin') || groups.includes('operation')) || (groups.includes('expert') && isTeamLeader))"
            [ngClass]="groups.includes('admin') ? 'column-inner' : 'column-inner-other-user' "
            >
            <div class="count-and-button">
                <h3>Activities | Count: {{ adminValetActivities.length }}</h3>
                <!-- <button class="btn hvr-grow has-margin-right" *ngIf="adminValetActivities.length && ((groups.includes('admin')) || (groups.includes('expert') && isTeamLeader))" (click)="changeActivityOrderAccordingTime()"> 
                    Reorder With Time
                </button> -->
            </div>
            <div class="card-container" *ngFor="let activity of adminValetActivities, index as i" 
                cdkDragLockAxis="y" 
                cdkDragBoundary="#activitiesList" 
                cdkDrag>
                <!-- Action Buttons -->
                <div class="action-btns drag-icon">
                    <i class="material-icons" cdkDragHandle *ngIf="selected">reorder</i>
                    <a matTooltip="Go to Consegna" class="action-icon" style="color: #F44336;" [href]="'/consegne/' + activity?.delivery?.id" target="_blank">
                        <i class="material-icons" style="cursor: pointer !important;">open_in_new</i>
                    </a>
                    <i *ngIf="activity?.delivery?.notes || activity?.delivery?.internalNotes" matTooltip="Notes" class="material-icons action-icon" style="cursor: pointer !important; color: #F44336;" (click)="openNotesDialauge(activity?.delivery)">sticky_note_2</i>
                </div>

                <!-- Accordion Header -->
                <div class="accordion-header" (click)="toggleAccordion('activity', i)">
                    <div class="flex-box">
                        <div class="flex-col">
                            <div class="accordion-img-container">
                                <div class="photo-container">
                                    <div class="date">
                                        <div class="day">{{ activity?.delivery?.deliveryDate | date: 'dd' }}</div>
                                        <div class="month">{{ activity?.delivery?.deliveryDate | date: 'MMM' | uppercase }}</div>
                                    </div>
                                </div>
                                <div class="service-image-container">
                                    <div class="date">
                                        <p>
                                            <img class="service-img" [src]="showServiceDetails(activity?.delivery)?.service?.image" width="50" height="50" *ngIf="showServiceDetails(activity?.delivery)?.service?.image">
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div class="event-name"> 
                                <span 
                                    [ngStyle]="{
                                        color: activity?.activityType?.toLowerCase() === 'pickup' ? '#FFC107' : 
                                            activity?.activityType?.toLowerCase() === 'delivery' ? '#007BFF' : 
                                            activity?.activityType?.toLowerCase() === 'hourlyservice' ? '#28A745' : ''
                                    }">
                                    {{
                                        activity?.activityType?.toLowerCase() === 'pickup' ? 'RITIRO' :
                                        activity?.activityType?.toLowerCase() === 'delivery' ? 'CONSEGNA' :
                                        activity?.activityType?.toLowerCase() === 'hourlyservice' ? 'SERVIZIO ORA' : ''
                                    }}
                                    :  {{ activity?.ddtNumber ? showDeliveryAndSaleIds(activity) : activity?.delivery?.id }}
                                    {{ selected ? activity?.order != null ? "(ORDER) " + activity?.order : "(NOT ORDERED)" : "" }}
                                </span>
                            </div>
                        </div>
                        <div class="info-container">
                            <table class="table-product" border="1">
                                <thead>
                                    <tr>
                                    <th>Product</th>
                                    <th>Quantity</th>
                                    </tr>
                                </thead>
                                <tbody >
                                <tr *ngFor="let dProduct of getProducts(activity)">
                                    <td>{{ dProduct.product?.name }} - {{ dProduct?.productVariant?.variantName }}</td>
                                    <td>{{ dProduct?.quantity }}</td>
                                </tr>
                                </tbody>
                            </table>
                            <span *ngIf="(activity?.activityType?.toLowerCase() === 'pickup')">
                                <b>ORA RITIRO: </b>{{ activity?.delivery?.pickUpTime || "---"}}
                                <br class="clear">
                            </span>
                            <span *ngIf="((activity?.activityType?.toLowerCase() === 'delivery') || (activity?.activityType?.toLowerCase() === 'hourlyservice'))">
                                <b>ORARIO: </b>{{ formatTimeShow(activity?.delivery?.fromTime, activity?.delivery?.toTime) }}
                                <br class="clear">
                            </span>
                            <span>
                                <b>PARTNER: </b>{{ activity?.delivery?.partner?.businessName || "---"}}
                                <br class="clear">
                            </span>
                            <span *ngIf="activity?.activityType?.toLowerCase() === 'pickup' || activity?.activityType?.toLowerCase() === 'hourlyservice'">
                                <b>INDIRIZZO DI RITIRO:: </b>{{ (activity?.delivery?.pickUpAddress) }}
                                <br class="clear">
                            </span>
                            <span *ngIf="activity?.activityType?.toLowerCase() === 'delivery' || activity?.activityType?.toLowerCase() === 'hourlyservice'">
                                <b>INDIRIZZO: </b>{{ (activity?.delivery?.address) }}
                                <br class="clear">
                            </span>
                            <!-- <span *ngIf="activity?.delivery?.serviceType.toLowerCase() === 'sales' ">
                                <b>PRODUCT: </b><span *ngFor="let dProduct of activity?.delivery?.deliveryProducts">{{dProduct.product?.name}}</span>
                                <br class="clear">
                            </span> -->
                        </div>
                    </div>
                    <div class="toggle-icon">
                        <i class="material-icons" [ngClass]="{'rotate-icon': activeAccordionActivityIndex === i}">expand_more</i>
                    </div>
                </div>

                <!-- Accordion Body -->
                <div class="accordion-body" *ngIf="activeAccordionActivityIndex === i">
                    <div class="additional-info">
                        <p>
                            <img class="service-img" [src]="showServiceDetails(activity?.delivery)?.service?.image" width="50" height="50" *ngIf="showServiceDetails(activity?.delivery)?.service?.image">
                        </p>
                        <p><strong>ORARIO:</strong> <b>{{ formatTimeShow(showingActivity.delivery.fromTime, showingActivity.delivery.toTime) }}</b></p>
                        <p *ngIf="!showingActivity?.delivery?.customer"><strong>NOME E COGNOME: </strong> <b>{{ showingActivity?.delivery?.name || "---" }}  {{ showingActivity?.delivery?.surname || "---" }}</b></p>
                        <p *ngIf="showingActivity?.delivery?.customer"><strong>NOME E COGNOME: </strong> <b>{{ showingActivity?.delivery?.customer?.user?.name || "---" }}  {{ showingActivity?.delivery?.customer?.user?.surname || "---" }}</b></p>
                        <p *ngIf="!showingActivity?.delivery?.customer"><strong>CITOFONO: </strong> <b>{{ showingActivity?.delivery?.intercom || "---" }}</b></p>
                        <p *ngIf="showingActivity?.delivery?.customer"><strong>CITOFONO: </strong> <b>{{ showingActivity?.delivery?.customer?.intercom || "---" }}</b></p>
                        <p><strong>PARTNER:</strong> {{ showingActivity.delivery.partner?.businessName }}</p>
                        <p><strong>INDIRIZZO:</strong> {{((showingActivity.delivery.address ? showingActivity.delivery.address : "") + (showingActivity.delivery.city ? ", " + showingActivity.delivery.city : "")) || "---"}}</p>
                        <p><strong>INDIRIZZO DI RITIRO:</strong> {{showingActivity.delivery?.pickUpAddress || "---"}}</p>
                        <p><strong>ORA RITIRO:</strong> <b>{{ showingActivity.delivery?.pickUpTime || "---"}}</b></p>
                        <p><strong>NOTE:</strong> <b>{{ showingActivity.delivery?.notes || "---"}}</b></p>
                        <p>
                            <strong>TIPO SERVIZIO:</strong> 
                            {{ showingActivity.delivery?.serviceType &&
                                (showingActivity?.delivery?.serviceType?.toLowerCase() === "fixedprice" ? "Servizi a Prezzo Fisso" :
                                (showingActivity?.delivery?.serviceType?.toLowerCase() === "hourlyrate" ? "Servizi a Ora" :
                                (showingActivity?.delivery?.serviceType?.toLowerCase() === "sales" ? "Servizi Vendita" : ""))) 
                            }}           
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <!-- activity-listing -->
    </div>
</section>